import { StyledLabel } from './ToggleSwitch.styled'

import type { ComponentPropsWithoutRef } from 'react'

type Props = Omit<ComponentPropsWithoutRef<'input'>, 'type' | 'checked' | 'onChange'> & {
  checked: boolean
  onChange: () => void
}

/**
 * Controlled Toggle Switch. This switch expects to be controlled with
 * outside state (inversion of control) to make it Flexible
 */
export const ToggleSwitch = ({ checked, onChange, id, disabled, ...props }: Props) => {
  const inputId = id ?? 'checkbox'

  return (
    <StyledLabel htmlFor={inputId} checked={checked} disabled={disabled}>
      <input id={inputId} type='checkbox' checked={checked} onChange={onChange} disabled={disabled} {...props} />
    </StyledLabel>
  )
}
